import { useState } from "react";
import PageHeader from "../../../Layout/PageHeader";
import FormButton from "../../../Components/Buttons/FormButton";
import InputFiled from "../../../Components/FormTag/InputFiled";
import {
  ALPHA_ONE_SPACE_REGEX,
  DATE_REGEX,
  NUMBER_REGEX,
} from "../../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../../Shared/Helper/ValidationMessage";
import { createCheckIn } from "./CheckIn.type";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export default function CheckInAddEdit() {
  const navigation = useNavigate();
  const [checkInData, setCheckInData] = useState<createCheckIn>(
    new createCheckIn()
  );
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<createCheckIn>({
    defaultValues: checkInData,
  });
  const nextData: SubmitHandler<createCheckIn> = (data) => {
    setCheckInData(data);
    navigation("/inbound/asn/checkin");
  };
  const handleCancelBtn = () => {
    navigation("/inbound/asn/checkin");
  };
  return (
    <>
      <PageHeader
        addUrl="/inbound/asn/checkin/add"
        listUrl="/inbound/asn/checkin"
        viewType={true}
      />
      <h5 className="text-start mt-1 mb-3">Create Check In</h5>

      <div className="my-2 bg-white rounded py-4 px-2 h-100">
        <form>
          <div className="d-flex px-2 gap-3">
            <div className="col-5 px-2">
              <label className="fw-medium">Actual Date</label>
              <div>
                <InputFiled
                  tabIndex={1}
                  autoFocus={true}
                  type="date"
                  register={register}
                  name="actualDate"
                  errors={errors.actualDate}
                  className="form-control mt-1"
                  placeholder="MM/DD/YYYY"
                  pattern={{ type: DATE_REGEX, message: PATTERN_ERR_MSG }}
                />
              </div>
            </div>
            <div className="col-5 px-2">
              <label className="fw-medium">Actual Time</label>
              <div>
                <InputFiled
                  tabIndex={2}
                  type="time"
                  register={register}
                  name="actualTime"
                  errors={errors.actualTime}
                  className="form-control mt-1"
                  placeholder="HH:MM"
                  //   pattern={{ type: DATE_REGEX, message: PATTERN_ERR_MSG }}
                />
              </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-5 px-2 ">
              <label className="fw-medium">Vehicle No.</label>
              <div>
                <InputFiled
                  tabIndex={3}
                  type="text"
                  register={register}
                  name="vehicleNo"
                  errors={errors.vehicleNo}
                  className="form-control mt-1"
                  placeholder="Enter Vehicle No."
                />
              </div>
            </div>
            <div className="col-5 px-2">
              <label className="fw-medium">Driver Name</label>
              <div>
                <InputFiled
                  tabIndex={4}
                  type="text"
                  register={register}
                  name="driverName"
                  errors={errors.driverName}
                  className="form-control mt-1"
                  placeholder="Enter Driver Name"
                  pattern={{
                    type: ALPHA_ONE_SPACE_REGEX,
                    message: PATTERN_ERR_MSG,
                  }}
                />
              </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-5 px-2">
              <label className="fw-medium">Tracking #</label>
              <div>
                <InputFiled
                  tabIndex={5}
                  type="text"
                  register={register}
                  name="tracking"
                  errors={errors.tracking}
                  className="form-control mt-1"
                  placeholder="Enter Tracking"
                  pattern={{ type: NUMBER_REGEX, message: PATTERN_ERR_MSG }}
                />
              </div>
            </div>
            <div className="col-5 px-2">
              <label className="fw-medium">Door</label>
              <div>
                <InputFiled
                  tabIndex={6}
                  type="text"
                  register={register}
                  name="door"
                  errors={errors.door}
                  className="form-control mt-1"
                  placeholder="Enter door"
                />
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="mt-auto d-flex flex-column">
      <div className="bg-white rounded py-3 mt-auto">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={7}
            className="sph-btn me-4"
            handleClick={handleSubmit(nextData)}
          >
            Submit
          </FormButton>
          <FormButton
            tabIndex={8}
            className="sph-btn sph-shift me-4"
            handleClick={handleCancelBtn}
          >
            Cancel
          </FormButton>
        </div>
      </div>
      </div>
    </>
  );
}
